import { faThumbsDown, faThumbsUp } from '@fortawesome/pro-light-svg-icons'
import React, { ChangeEvent, FC, useState } from 'react'

import { httpRequest } from '../../common/network'
import { Button } from '../../layout_components/Button'
import { InputArea } from '../../layout_components/common.components'
import { locale } from '../../locales/locale'
import { FeedbackInfo } from '../definitions'
import {
  FeedbackButtons,
  FeedbackComment,
  FeedbackContainer,
} from './feedback.components'

interface Props {
  article: number
}

const Feedback: FC<Props> = (props: Props) => {
  const [feedback, setFeedback] = useState<FeedbackInfo>({
    id: null,
    feedback: undefined,
    completed: false,
    text: '',
    feedbackComment: null,
    counter: 0,
  })
  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const comment = e.target.value.slice(0, 600)
    setFeedback({
      ...feedback,
      feedbackComment: comment,
      counter: comment.length,
    })
  }

  const saveFeedback = (newFeedback: 'yes' | 'no') => {
    httpRequest({
      method: 'POST',
      path: 'help/article/feedback',
      data: {
        data: {
          article_id: props.article,
          feedback: newFeedback,
          feedback_comment: feedback.feedbackComment,
          feedback_id: feedback.id,
        },
      },
      onSuccess: (response: { data: { id: number; commented: boolean } }) => {
        setFeedback({
          ...feedback,
          feedback: newFeedback,
          id: response.data.id,
          completed: response.data.commented,
        })
      },
      onError: () => {
        // Do not show alert
        setFeedback({ ...feedback, feedback: 'yes' })
      },
    })
  }

  return (
    <FeedbackContainer>
      <h3>{locale("L'articolo è stato utile?")}</h3>
      <FeedbackButtons>
        {feedback.feedback === undefined ? (
          <>
            <Button
              type={'text'}
              onClick={() => saveFeedback('yes')}
              iconLeft={faThumbsUp}
              text={locale('Si, Grazie!')}
              customClass={'yes'}
              isFeedback={true}
            />
            <Button
              type={'text'}
              onClick={() => saveFeedback('no')}
              iconLeft={faThumbsDown}
              text={locale('Non è servito')}
              customClass={'no'}
              isFeedback={true}
            />
          </>
        ) : feedback.feedback === 'yes' || feedback.completed ? (
          <p>{locale('Grazie per aver lasciato il tuo feedback!')}</p>
        ) : (
          <p>
            {locale('Ci dispiace di non esserti stati di aiuto.')}
            <br />
            {locale('Se vuoi puoi lasciare un commento per dirci come migliorare.')}
          </p>
        )}
      </FeedbackButtons>
      {feedback.feedback === 'no' && !feedback.completed && (
        <FeedbackComment valid={feedback.feedbackComment !== null}>
          <InputArea
            name={'feedbackComment'}
            maxLength={600}
            onChange={handleChange}
            value={feedback.feedbackComment}
          />
          <>
            <Button
              style={{ float: 'right' }}
              type={'text'}
              isDisabled={!feedback.feedbackComment}
              text={locale('Invia feedback')}
              onClick={() =>
                feedback.feedbackComment ? saveFeedback('no') : undefined
              }
            />
          </>
        </FeedbackComment>
      )}
    </FeedbackContainer>
  )
}

export default Feedback
